export const listagem = {
  mounted () {
    if (this.url) {
      this.listar()
    }
  },
  data () {
    return {
      loading: false,
      lista: [],
      filtro: {},
      pagina: {},
      sortField: 'id',
      sortOrder: 'DESC',
      page: 0,
      perPage: 20,
      url: null,
      paginar: false,
      metodo: 'GET'
    }
  },
  methods: {
    listar () {
      if (this.metodo === 'PUT') {
        this.listarPut()
      } else {
        this.listarGet()
      }
    },
    listarGet () {
      this.loading = true
      this.$http.get(this.url, this.$header()).then(
        res => this.listagemCarregada(res), res => this.mensagemFalha(res))
    },
    listarPut () {
      this.loading = true
      this.$http.put(this.url, this.filtro, this.$header()).then(
        res => this.listagemCarregada(res), res => this.mensagemFalha(res))
    },
    onPageChange (page) {
      this.page = page - 1
      this.listarPut()
    },
    onSort (field, order) {
      this.sortField = field
      this.sortOrder = order
      this.listarPut()
    },
    filtrar () {
      this.resetPagina()
      this.listar()
    },
    limparFiltro () {
      this.filtro = {}
      this.filtrar()
    },
    resetPagina (perPage) {
      this.page = 0
      if (perPage) {
        this.perPage = perPage
      } else {
        this.perPage = 20
      }
    },
    mensagemSucesso (res) {
      this.toast(res)
      this.loading = false
    },
    listagemCarregada (res) {
      if (this.paginar) {
        this.pagina = res.body
        this.lista = this.pagina.content
      } else {
        this.lista = res.body
      }
      this.loading = false
    },
    mensagemFalha (res) {
      this.toast(res)
      this.loading = false
    },
    toast (res) {
      let msg = res.body.message
      let tipo
      switch (res.status) {
        case 401:
          tipo = 'is-danger'
          msg = 'Token inválido! Favor logar novamente.'
          break
        case 0:
        case 404:
          tipo = 'is-warning'
          msg = 'Ops! Nosso servidor está offline, tente novamente mais tarde.'
          break
        case 422:
        case 500:
          tipo = 'is-danger'
          break
        case 200:
          tipo = 'is-info'
          break
        case 201:
          tipo = 'is-success'
          break
      }
      this.$toast.open({
        message: msg,
        type: tipo,
        duration: 7 * 1000
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/listagem.js